import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';

export const readTwilioTokenV1 = async <T extends Record<string, unknown>>({
  headers,
  domain,
  query,
  signal,
}: FetchRequestArgs): Promise<ReturnType<typeof fetchRequest>> =>
  fetchRequest<T>({
    domain,
    endpoint: '/v1/twilio/token',
    headers,
    query,
    signal,
  });
